//------------------------------------------------------------------------------
// Node Modules ----------------------------------------------------------------
import React from 'react';
import qs from 'query-string';
import client from '@api/client';
import GET from '@api/methods/get';
import { storeValue } from '@helpers/localStorage';
import { refCode, StripeStatus } from '@helpers/constants/localStorage';

//------------------------------------------------------------------------------
// Endpoints -------------------------------------------------------------------
const Endpoints = {
  Providers: {
    url: `/providers/me`,
  },
};
//------------------------------------------------------------------------------
// React Classes ---------------------------------------------------------------
export const Providers = ({ children, pathParams, ...props }) => {
  const onComplete = (data) => {
    storeValue(refCode, data.referralCode);
    storeValue(StripeStatus, data.stripeStatus);
    if (props.onComplete) {
      props.onComplete(data);
    }
  };
  return (
    <GET endpoint={Endpoints.Providers} {...props} onComplete={onComplete}>
      {children}
    </GET>
  );
};

//------------------------------------------------------------------------------
// Inline ----------------------------------------------------------------------
export const loadProviders = (params) => {
  const stringifiedParams = qs.stringify(params, {
    encode: false,
    skipNull: true,
  });
  return client.get(`${Endpoints.Providers.url}?${stringifiedParams}`);
};

export const loadEligibileRewardSelections = () => {
  return client.get('/providers/eligible-reward-selections');
};

export const getConfigByKey = (key) => {
  return client.get(`/providers/config?key=${key}`);
};

export const getProviderQRStatus = (vetHCode) => {
  return client.get(`providers/find-vet-exists-quick-reco?hCode=${vetHCode}`);
};
